<script lang="ts">
	import { format } from 'svelte-i18n';
	import { FlexibleCard } from '@Shelly/shelly-design-system';
	import { getTimeDuration } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_session_info_helpers';
	//Types
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let statuses: VCInterfaceStatus[];
</script>

<div class="grid mb-s">
	<FlexibleCard
		backgroundColor={$showNewLayout ? '--color-0' : undefined}
		padding="m"
		class="d-block"
		mainContentPrioritySlot="both"
		header={$format('label_charging_duration', {
			default: 'Charging duration',
		})}
		icon="far fa-clock"
	>
		{getTimeDuration(statuses.find((i) => i.name == 'time_charge')?.rawValue ?? 0)}
	</FlexibleCard>
	<FlexibleCard
		backgroundColor={$showNewLayout ? '--color-0' : undefined}
		padding="m"
		class="d-block"
		mainContentPrioritySlot="both"
		header={$format('label_energy_delivered', { default: 'Energy delivered' })}
		icon="fas fa-gauge-circle-bolt"
	>
		{statuses.find((i) => i.name == 'energy_charge')?.value}
	</FlexibleCard>
</div>

<style>
	.grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
		gap: var(--spacing-s);
	}
</style>
